<template>
    <b-modal
        id="project-add-to-whom-course-modal"
        v-model="showModal"
        size="md"
        ref="project-add-to-whom-course-modal"
        hide-footer
        :ok-title="$t('common.delete')"
        :title="$t('project.who_do_you_want_to_add_the_course_for')"
        modal-class="apprentice-default-modal courses-modal">
        <b-form-group
            class="course-add-group"
            v-slot="{ ariaDescribedby }"
            :label="$t('project.who_do_you_want_to_add_the_course_for')"
            label-for="course-add-radio-select">
            <b-form-radio-group
                v-model="selectedUser"
                :options="buttons"
                :aria-describedby="ariaDescribedby"
                buttons
                html-field="html"
                button-variant="outline-primary"
                @change="addCourse">
            </b-form-radio-group>
        </b-form-group>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-project-add-course-to-whom-modal-component',
    props: ['projectIn', 'commonMaxReachedIn', 'personalMaxReachedIn'],
    data() {
        return {
            course: null,
            showModal: false,
            selectedUser: 0,
        };
    },
    methods: {
        show(course) {
            this.course = course;
            this.showModal = true;
        },
        addCourse(userId) {
            this.$emit('addSpecific', {
                userId: userId,
                courseId: this.course.id,
            });
            this.showModal = false;
        },
    },
    computed: {
        buttons() {
            if (this.course) {
                let buttonArray = [];
                if (this.$authUser.isStudent()) {
                    if (!this.personalMaxReachedIn) {
                        buttonArray.push({
                            text: this.$t('project.for') + this.$authUser.full_name,
                            userId: this.$authUser.id,
                            value: this.$authUser.id,
                            html: `<span class="user"><i class="icon fad fa-user"></i>${this.$authUser.full_name}</span>`,
                        });
                    }
                } else {
                    buttonArray = this.projectIn.users
                        .filter((user) => user.type === 'student' && !this.course.personalIds.includes(user.id))
                        .map((user) => {
                            return {
                                text: this.$t('project.for') + user.full_name,
                                html: `<span class="user"><i class="icon fad fa-user"></i>${user.full_name}</span>`,
                                value: user.id,
                                userId: user.id,
                            };
                        });
                }
                if (!this.course.common && !this.commonMaxReachedIn) {
                    buttonArray.push({
                        text: this.$t('project.for_the_whole_group'),
                        html: `<span class="group"><i class="icon fad fa-users"></i>this.$t('project.whole_group')</span>`,
                        value: null,
                        userId: null,
                    });
                }

                return buttonArray;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.course-add-group ::v-deep {
    .btn-group-toggle {
        label {
            border-radius: 8px;

            &:not(:last-child) {
                border-radius: 8px;
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
}

::v-deep .user,
::v-deep .group {
    .icon {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}
</style>
